import { render, staticRenderFns } from "./RendererImage.vue?vue&type=template&id=24996893"
import script from "./RendererImage.vue?vue&type=script&lang=js"
export * from "./RendererImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports